export default "__VITE_ASSET__BjcSeQrt__"